module.exports = __webpack_public_path__ + "static/media/W5390484_11.6433d87b.jpg";